export default {"src":"/_next/static/media/caret_down.d80899d2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};